/**
 * shadow
 * @param elevation 0 ~ 24 for different elevation shadow
 */
export function shadows(elevation) {
    return function (_a) {
        var theme = _a.theme;
        return theme.shadows[elevation];
    };
}
